/* tslint:disable */
/* eslint-disable */
/**
 * AIS Coverage API
 * API for managing AIS source identifiers and calculating coverage.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSourceIdentifier
 */
export interface UpdateSourceIdentifier {
    /**
     * Position in WKT format (e.g., "POINT(long lat)").
     * @type {string}
     * @memberof UpdateSourceIdentifier
     */
    pos?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSourceIdentifier
     */
    covEnabled?: boolean;
}

/**
 * Check if a given object implements the UpdateSourceIdentifier interface.
 */
export function instanceOfUpdateSourceIdentifier(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateSourceIdentifierFromJSON(json: any): UpdateSourceIdentifier {
    return UpdateSourceIdentifierFromJSONTyped(json, false);
}

export function UpdateSourceIdentifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSourceIdentifier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pos': !exists(json, 'pos') ? undefined : json['pos'],
        'covEnabled': !exists(json, 'cov_enabled') ? undefined : json['cov_enabled'],
    };
}

export function UpdateSourceIdentifierToJSON(value?: UpdateSourceIdentifier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pos': value.pos,
        'cov_enabled': value.covEnabled,
    };
}

